<!--
component: ListShiteiResult
author: Ken Nakamura
description: 位置指定道路 番号検索結果リスト
-->
<template>
  <section>
    <v-data-table
      :headers="headers" :items="shitei"
      :fixed-header="false" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer
      :single-select="true" item-key="id"
      class="elevation-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td>{{item.shiteiNo}}</td>
            <td>{{item.kuName}}</td>
            <td>{{dateTextToWareki(item.shiteiDay)}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki } from '../common/utils'

export default {
  data: () => {
    return {
      loading: false,
      headers: [
        {
          text: '指定番号',
          value: 'shiteiNo'
        },
        {
          text: '区名',
          value: 'kuName'
        },
        {
          text: '指定日',
          value: 'shiteiDay'
        },
      ],
    }
  },
  props: {
  },
  computed: {
    shitei () {
      return this.$store.state.summaries;
    },
  },
  methods: {
    /**
     * 日付の和暦表示
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },   
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListShiteiResult.selectRow(${target.id})`);
      this.$store.commit('setGaiyoId', target.id);
      this.$store.commit('setUkeNo', target.shiteiNo);
      this.shitei.forEach((k) => {
        k.active = (k === target);
      });
    },
  },
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>